import { createPluginSpec } from '#src/plugins/spec/types.js';
export function createNewModelTransformerWebConfig(config) {
    return config;
}
export function createModelTransformerWebImplementation() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformers = new Map();
    return {
        registerTransformerWebConfig(transformer) {
            if (transformers.has(transformer.name)) {
                throw new Error(`Model transformer with name ${transformer.name} is already registered`);
            }
            transformers.set(transformer.name, transformer);
        },
        getTransformerWebConfig(name, builtInTransformers = []) {
            const builtInTransformer = builtInTransformers.find((b) => b.name === name);
            if (builtInTransformer) {
                return builtInTransformer;
            }
            const transformer = transformers.get(name);
            if (!transformer) {
                throw new Error(`Unable to find transformer with name ${name}`);
            }
            return transformer;
        },
        getTransformerWebConfigs(builtInTransformers = []) {
            return [...builtInTransformers, ...transformers.values()];
        },
    };
}
/**
 * Spec for adding config component for plugin
 */
export const modelTransformerWebSpec = createPluginSpec('core/model-transformer-web', { defaultInitializer: createModelTransformerWebImplementation });
//# sourceMappingURL=model-transformer-web-spec.js.map